



























































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { onlyNumber } from '@/utils/common'

@Component

export default class ComponentBackofficeProcedimentoAutorizarQuantidade extends Vue {
  @Prop({ default: false, required: false }) comentarios: boolean
  @Prop({ default: false, required: false }) comentariosDisabled: boolean
  @Prop({ default: false, required: false }) autorizacaoDisabled: boolean

  $refs!: {
    pendenciaAutorizar: any,
    autorizacaoFinalizar: any,
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get lateralidadeEmProcedimento() {
    const { template } = this.getBackofficeGlobalStore
    return template && template.formulario && template.formulario.lateralidade && template.formulario.lateralidade.lateralidadeEmProcedimento
  }

  get headers() {
    const headers = this.lateralidadeEmProcedimento
      ? [
        { text: 'Procedimento', class: 'table-headers', align: 'left', sortable: false, value: 'descricao' },
        { text: 'Qtde. solicitada', class: 'table-headers', align: 'center', sortable: false, value: 'quantidade' },
        { text: 'Lateralidade', class: 'table-headers', align: 'center', value: 'lateralidade', sortable: false },
        { text: 'Qtde. autorizada', class: 'table-headers', align: 'center', sortable: false, value: 'quantidadeAutorizada' },
        { text: 'Comentarios', class: 'table-headers', align: 'center', sortable: false, value: '' },
      ]
      : [
        { text: 'Procedimento', class: 'table-headers', align: 'left', sortable: false, value: 'descricao' },
        { text: 'Qtde. solicitada', class: 'table-headers', align: 'center', sortable: false, value: 'quantidade' },
        { text: 'Qtde. autorizada', class: 'table-headers', align: 'center', sortable: false, value: 'quantidadeAutorizada' },
        { text: 'Comentarios', class: 'table-headers', align: 'center', sortable: false, value: '' },
      ]

      return headers
  } 

  isStatusAguardandoOperadoraAutorizada(authorizedValue) {
    return this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora === 'Autorizada'
      ? authorizedValue
      : 0
  }

  dial: boolean = false
  dialModel: string | null | undefined = ''
  get dialog() { return this.dial }
  set dialog(value: boolean) { this.dial = value }
  get dialogModel() { return this.dialModel }
  set dialogModel(value: any) { this.dialModel = value }

  setDialog(model: any) {
    this.dialogModel = model
    this.dialog = true
  }

  closeDialog() {
    this.dialog = false
  }

  quantidadeRules: any = {
    valid: true,
    quantidade: [v => (v !== null && v !== '') || 'Campo obrigatório.'],
  }

  get getProcedimentos() {
    const a = this.getBackofficeGlobalStore.solicitacao.procedimentosAssociados ? this.getBackofficeGlobalStore.solicitacao.procedimentosAssociados : []
    const procedimentos = [this.getBackofficeGlobalStore.solicitacao.procedimento, ...a].map((p: any) => {
      const proc = p
      proc.observacaoDaAutorizacao = proc.observacaoDaAutorizacao ? proc.observacaoDaAutorizacao : ''
      return proc
    })
    return procedimentos
  }

  get doctorsSurgeryTeam() {
    return this.getBackofficeGlobalStore.solicitacao.equipeCirurgica
  }

  // Somente para visualização no agendamento

  get anestesiaDoHospital() {
    if (this.getBackofficeGlobalStore.solicitacao.anestesiaDoHospital === 'Sim') return 'Sim'
    if (this.getBackofficeGlobalStore.solicitacao.anestesiaDoHospital === 'Nao') return 'Não'
    return 'Não se aplica'
  }

  get anestesista() {
    return this.getBackofficeGlobalStore.solicitacao.anestesista
  }

  get temPrecaucoes() {
    return (this.getBackofficeGlobalStore.solicitacao.precaucoes && this.getBackofficeGlobalStore.solicitacao.precaucoes.key !== 'Nao')
      ? 'Sim'
      : 'Não'
  }

  displayExamesIntraOperatorios(exame: any) {
    const equipeHospital = exame !== null && exame.key && exame.key.toLowerCase() === 'ultrassonografiaintraoperatoria' && exame.equipeDoHospital !== null
      ? ` - Precisa da equipe do hospital: ${exame.equipeDoHospital ? 'SIM' : 'NÃO'} `
      : ''

    const outros = exame !== null && exame.key && exame.key.toLowerCase() === 'outros' && exame.outrosEspecificar !== null
      ? ` - ${!['', null, undefined].includes(exame.outrosEspecificar) ? exame.outrosEspecificar : '-'} `
      : ''

    const hospitalOuParticular = exame !== null && exame.key && exame.hospitalOuParticular
      ? ` - Origem do serviço: ${!['', null, undefined].includes(exame.hospitalOuParticular) ? exame.hospitalOuParticular : '-'} `
      : ''

    const particularLocal = exame !== null && exame.key && exame.particularLocal
      ? ` - Local de prestação do serviço: ${!['', null, undefined].includes(exame.particularLocal) ? exame.particularLocal : '-'} `
      : ''

    return `${exame ? exame.display : ''} ${equipeHospital}${outros}${hospitalOuParticular}${particularLocal}`
  }

  precaucoes(item) {
    if (item.precaucoes && item.precaucoes.key === 'Sim') return item.especificarPrecaucoes
    if (item.precaucoes && item.precaucoes.key === 'Outro') return item.especificarPrecaucoes
    if (item.precaucoes && item.precaucoes.key === 'PrecaucaoRespiratoriaPorGoticulas') return 'Precaução respiratória por gotículas'
    if (item.precaucoes && item.precaucoes.key === 'PrecaucaoRespiratoriaPorAerosol') return 'Precaução respiratória por aerosol'
    if (item.precaucoes && item.precaucoes.key === 'PrecaucaoPorContatoERespiratoriaPorAerosol') return 'Precaução por contato respiratório por aerosol'
    if (item.precaucoes && item.precaucoes.key === 'PrecaucaoEspecial') return 'Precaução especial'
    return 'Não'
  }

  campoHabilitado(prop: string) {
    if (this.getBackofficeGlobalStore.template.formulario) {
      const response = this.getBackofficeGlobalStore.template.formulario[prop]
      if (response) return response.habilitado
    }

    return false
  }

  opcaoHabilitado(prop1: string, prop2: string) {
    if (this.getBackofficeGlobalStore.template.formulario) {
      const response = this.getBackofficeGlobalStore.template.formulario[prop1]
        && this.getBackofficeGlobalStore.template.formulario[prop1].campos
        && this.getBackofficeGlobalStore.template.formulario[prop1].campos[prop2]
      return response
    }

    return false
  }

  isValid() {
    let isValidated: boolean = true

    this.getProcedimentos.map((p, index) => {
      if (!this.$refs[`formQuantidade${index}`].validate()) {
        isValidated = false
      }
      return p
    })

    return isValidated
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }
}
